var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("This is the page for data preparation")]),_c('button',{on:{"click":_vm.seedData}},[_vm._v("Seed Data Now")])])}
var staticRenderFns = []

export { render, staticRenderFns }